var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "question", class: _vm.iosClassName },
    [
      _c("v-cover", {
        staticClass: "question__cover",
        attrs: {
          image: _vm.question.bulyImage,
          title: _vm.question.title || "Question",
          description: _vm.question.description,
          overlay: "",
        },
      }),
      _vm.isSkinToneStep
        ? _c(
            "div",
            {
              staticClass: "question__skin-tones",
              class: _vm.answersClassName,
            },
            _vm._l(_vm.answers, function (answer) {
              return _c("v-option", {
                directives: [
                  {
                    name: "touch",
                    rawName: "v-touch:tap",
                    value: () => _vm.selectAnswer(answer),
                    expression: "() => selectAnswer(answer)",
                    arg: "tap",
                  },
                ],
                key: answer.id,
                staticClass: "question__skin-tone",
                class: { gradient__color: !_vm.question.bulyNoTextAnswer },
                attrs: {
                  image: answer.bulyImage,
                  "no-text":
                    _vm.question.bulyNoTextAnswer ||
                    _vm.question.id === "extra",
                  "full-image": _vm.question.bulyIsimagefull,
                },
              })
            }),
            1
          )
        : _c(
            "div",
            { staticClass: "question__answers", class: _vm.answersClassName },
            _vm._l(_vm.answers, function (answer) {
              return _c(
                "v-option",
                {
                  directives: [
                    {
                      name: "touch",
                      rawName: "v-touch:tap",
                      value: () => _vm.selectAnswer(answer),
                      expression: "() => selectAnswer(answer)",
                      arg: "tap",
                    },
                  ],
                  key: answer.id,
                  staticClass: "question__answer",
                  class: { gradient__color: !_vm.question.bulyNoTextAnswer },
                  attrs: {
                    image: answer.bulyImage,
                    "no-text":
                      _vm.question.bulyNoTextAnswer ||
                      _vm.question.id === "extra",
                    "full-image": _vm.question.bulyIsimagefull,
                  },
                },
                [_vm._v(" " + _vm._s(answer.title) + " ")]
              )
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }